import React from 'react'
import style from './articles.style'

const DSdataset = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Как создать набор данных для подключения ROMI center</h2>
      <p>
        Для того, чтобы создать набор данных,{' '}
        <strong>откройте Google Analytics в&nbsp;режиме инкогнито</strong>.
        На&nbsp;компьютерах с&nbsp;Windows, Linux и&nbsp;Chrome OS&nbsp;это
        комбинация клавиш: <strong>Ctrl+Shift+N</strong>. На&nbsp;компьютерах
        Mac: <strong>⌘+Shift+N</strong>. Нажмите необходимое сочетание клавиш
        находясь в&nbsp;браузере.
      </p>
      <p>
        Если не&nbsp;открыть Analytics в&nbsp;режиме инкогнито,
        то&nbsp;вы&nbsp;не&nbsp;сможете создать набор данных. Так как Analytics
        будет выдавать системное сообщение о&nbsp;том, что у&nbsp;вас{' '}
        <strong>&laquo;Нет доступа&raquo;</strong>. Пример:
      </p>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/image1nd.jpg" alt="true" />
      </figure>
      <h3>Шаг 1. Создание набора данных</h3>
      <ol>
        <li>
          Перейдите в режим <strong>Администратор</strong>
        </li>
        <li>
          Перейдите в раздел <strong>импорт данных</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image5nd.jpg" alt="true" />
        </figure>
        <li>
          Нажмите кнопку <strong>Создать</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image8nd.jpg" alt="true" />
        </figure>
        <li>
          В разделе <em>импорт</em> сводных данных, выберите{' '}
          <strong>Данные о расходах</strong>
        </li>
        <li>
          Нажмите кнопку <strong>Далее</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image2nd.jpg" alt="true" />
        </figure>
        <li>
          Введите название набора данных <strong>Romi_center_import</strong>
        </li>
        <li>
          В выпадающем списке поставьте галочку, напротив созданного ранее
          представления <strong>Romi center</strong>
        </li>
        <li>
          Нажмите кнопку <strong>Далее</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image4nd.jpg" alt="true" />
        </figure>
      </ol>
      <h3>Шаг 2. Схема набора данных</h3>
      <ol>
        <li>
          Во второй таблице, в выпадающем списке, поставьте галочки напротив:
          <strong>Стоимость, Число кликов и Число показов</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image3nd.jpg" alt="true" />
        </figure>
        <li>
          Во третьей таблице, в выпадающем списке, поставьте галочку напротив:
          <strong>Кампания</strong>
        </li>
        <li>
          В разделе <em>действия</em> при импорте, <strong>обязательно</strong>{' '}
          выберите <strong>Перезаписать</strong>
        </li>
        <li>
          Нажмите кнопку <strong>Сохранить</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image7nd.jpg" alt="true" />
        </figure>
        <li>
          Нажмите кнопку <strong>Готово</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image6nd.jpg" alt="true" />
        </figure>
      </ol>
    </article>
  )
}

export default style(DSdataset)
